import { render, staticRenderFns } from "./BuoyancyViz.vue?vue&type=template&id=19155c15&scoped=true"
import script from "./BuoyancyViz.vue?vue&type=script&lang=js"
export * from "./BuoyancyViz.vue?vue&type=script&lang=js"
import style0 from "./BuoyancyViz.vue?vue&type=style&index=0&id=19155c15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19155c15",
  null
  
)

export default component.exports